"use client";

import React, { ReactNode } from "react";
import styled from "styled-components"
import { blockPaddingBottom, Box } from "@motorata/base-ui.components.atoms._atoms";
import OffersSideBar from "@/views/offers/OffersSideBar";
import FilterProvider from "@/providers/FilterProvider";
import OffersContainerHeader from "@/views/offers/OffersContainerHeader";

const OffersTemplate = ({ children, seoChildren }: {
  children: ReactNode
  seoChildren: ReactNode
}) => {
  return (
    <FilterProvider>
      <Content>
        <OffersSideBar />
        <Box>
          <OffersContainerHeader />
          {children}
        </Box>
      </Content>
      {seoChildren}
    </FilterProvider>
  )
}

export default OffersTemplate

const Content = styled(Box)`
  ${blockPaddingBottom};
  display: grid;
  grid-template-columns: 1fr 2.5fr;
  grid-gap: ${({ theme }) => theme.space.M};
  max-width: 1300px;
  margin: 0 auto;
  
  @media (min-width: 800px){
    margin-top: -${({ theme }) => theme.space.M};
  }
  @media (max-width: 1200px) {
    display: flex;
    flex-direction: column-reverse;
  }
`
